import { DiscountBadge } from 'QuoteApp/components/DiscountBadge';
import React, { FC } from 'react';
import styles from './styles.module.css';
import { Button, Tooltip } from '@clearcover/atlas';

export type HeaderButton = {
  text: string;
  onClick: () => void;
  isSubmitting?: boolean;
  disabled?: boolean;
  tooltip?: string;
};

export type SummarySectionProps = {
  discountBadgeText?: string;
  headerText: string;
  subHeaderText?: string;
  children?: React.ReactNode;
  headerButton?: HeaderButton;
};

export const SummarySection: FC<SummarySectionProps> = ({
  discountBadgeText,
  headerText,
  subHeaderText,
  children,
  headerButton,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.headerWrapper}>
        <h3 className={styles.header}>
          {headerText}
          {discountBadgeText && (
            <DiscountBadge className={styles.discountBadge}>
              {discountBadgeText}
            </DiscountBadge>
          )}
        </h3>
        {headerButton && (
          <>
            {headerButton.tooltip ? (
              <Tooltip tooltip={headerButton.tooltip}>
                <Button
                  type="button"
                  variant="secondary"
                  onClick={headerButton.onClick}
                  className={styles.headerButton}
                  disabled={headerButton.disabled}
                  isSubmitting={headerButton.isSubmitting}
                >
                  {headerButton.text}
                </Button>
              </Tooltip>
            ) : (
              <Button
                type="button"
                variant="secondary"
                onClick={headerButton.onClick}
                className={styles.headerButton}
                disabled={headerButton.disabled}
                isSubmitting={headerButton.isSubmitting}
              >
                {headerButton.text}
              </Button>
            )}
          </>
        )}
      </div>
      <div className={styles.subText}>{subHeaderText}</div>
      {children}
    </div>
  );
};
